import { connect } from 'react-redux';
import {
  sectionEditStart,
  sectionEditStop,
  widgetEditStart,
  widgetEditStop,
  widgetStartSwitching,
  widgetStopSwitching,
  getWidgetSwitchingId,
} from 'store/modules/builder';
import {
  isLoaded,
  revise,
  saveVersion,
  getSubmissionStatus,
  getLayout,
} from 'store/modules/pageBuilder';
import { getCompanyName, getFlipper } from 'store/modules/company';
import { FLIPPER_SECTION_WIDGET_MOVING } from '../../../../../constants/flippers';
import Page from '../components/Page';

// TODO: Merge this connect with the `AdminPageBuilder` container's connect to turn Page into a simple component
export default connect(
  (state, props) => {
    const { id } = props;
    let page = null;
    let version = null;
    if (isLoaded(state, id)) {
      page = state.pageBuilder;
      version = page.version; // eslint-disable-line prefer-destructuring
    }

    return {
      page,
      version,
      pathname: state.routing.locationBeforeTransitions.pathname,
      hostnames: state.hostnames,
      companyName: getCompanyName(state),
      isSectionBeingEdited: section => state.builder.editingSections[section.id],
      isWidgetBeingEdited: id => state.builder.editingWidgets[id],
      layout: getLayout(state),
      sectionWidgetMoving: getFlipper(state, FLIPPER_SECTION_WIDGET_MOVING),
      isSubmitting: getSubmissionStatus(state),
      widgetSwitchingId: getWidgetSwitchingId(state),
    };
  },
  {
    saveVersion,
    revise,
    handleSectionEditStart: sectionEditStart,
    handleSectionEditStop: sectionEditStop,
    handleWidgetEditStart: widgetEditStart,
    handleWidgetEditStop: widgetEditStop,
    onStartWidgetSwitch: widgetStartSwitching,
    onStopWidgetSwitch: widgetStopSwitching,
  },
)(Page);
